import {
	type IApiResponse,
	type ITransactionHistory,
	type ITransactionHistorySellDoc,
	type ParamType,
	type TransactionHistoryType,
} from 'BreetHelpers';

import { apiSlice } from './apiSlice';

export const transactionsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getTransactionsSellServices: builder.query<IApiResponse<ITransactionHistory<ITransactionHistorySellDoc>[]>, ParamType>({
			query: (params) => ({
				url: '/transactions',
				params: { ...params, services: 'sells' },
				...(params?.exports ? { responseHandler: (response: Response) => response.blob() } : {}),
			}),
			providesTags: ['AllTransactions'],
		}),
		getTransactionSellServicesById: builder.query<IApiResponse<ITransactionHistory<ITransactionHistorySellDoc>>, string>({
			query: (id) => ({ url: `/transactions/transaction/${id}`, params: { services: 'sells' } }),
		}),
		getTransactionsEditServices: builder.query<
			IApiResponse<ITransactionHistory<TransactionHistoryType>[]>,
			ParamType & { defaultParams: string }
		>({
			query: ({ defaultParams, ...params }) => ({
				url: `/transactions${defaultParams}`,
				params,
				...(params.exports ? { responseHandler: (response: Response) => response.blob() } : {}),
			}),
			providesTags: ['AllTransactions'],
		}),
		getTransactionEditServicesById: builder.query<IApiResponse<ITransactionHistory<TransactionHistoryType>>, string>({
			query: (id) => ({ url: `/transactions/transaction/${id}?services=withdrawals&services=edits` }),
		}),
		addTransactionRating: builder.mutation<IApiResponse, { id: string; rating: number; comment: string }>({
			query: ({ id, ...body }) => ({
				method: 'POST',
				url: `/transactions/ratings/${id}`,
				body,
			}),
			invalidatesTags: ['AllTransactions'],
		}),
	}),
});

export const {
	useGetTransactionSellServicesByIdQuery,
	useGetTransactionsSellServicesQuery,
	useGetTransactionEditServicesByIdQuery,
	useGetTransactionsEditServicesQuery,
	useAddTransactionRatingMutation,
} = transactionsApiSlice;

export const selectTransactionSellServicesById = (id: string) =>
	transactionsApiSlice.endpoints.getTransactionSellServicesById.select(id);
